import "./FsnbCoefBox.css";

import { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";

import apiFsnb from "api/fsnb";
import AlertLoading from "components/AlertLoading";
import Table from "components/Table/Table";
import KsprButton from "components/UI/buttons/KsprButton";

import CoefTableColumns from "../TableSetting/CoefTableColumns";
import FsnbNrspSubBox from "./FsnbNrspSubBox";

export default function FsnbCoefBox(props) {
	const [data, setData] = useState([]);
	const scrollBlock = useRef(null);
	const [fetchStatus, setFetchStatus] = useState(null);
	const [fetchStatusText, setFetchStatusText] = useState("");
	const [nrpsRowsCnt, setNrspRowsCount] = useState(0);

	const columnsData = CoefTableColumns();

	useEffect(() => {
		setFetchStatus("loading");
		const prom = apiFsnb.getNormCoef(props.row.id);
		prom.then((responce) => {
			setData(responce.data);
			setFetchStatus("success");
		}).catch((error) => {
			console.error(error);
			setFetchStatus("failed");
			setFetchStatusText(error);
		});
	}, [props.row.id]);

	let boxWidth = "90%";
	if (props.width != null) boxWidth = props.width;

	const getHeight = (boxName) => {
		if (nrpsRowsCnt === 1) {
			if (boxName === "nrsp") return "59px";
			if (boxName === "nrsp_coef") return "101px";
			if (boxName === "nrsp_and_coef") return "265px";
			if (boxName === "coef") return "calc(100% - 356px)";
		} else if (nrpsRowsCnt === 2) {
			if (boxName === "nrsp") return "81px";
			if (boxName === "nrsp_coef") return "101px";
			if (boxName === "nrsp_and_coef") return "285px";
			if (boxName === "coef") return "calc(100% - 369px)";
		} else if (nrpsRowsCnt === 4) {
			if (boxName === "nrsp") return "122px";
			if (boxName === "nrsp_coef") return "101px";
			if (boxName === "nrsp_and_coef") return "325px";
			if (boxName === "coef") return "calc(100% - 410px)";
		}
	};

	let nrspBox = <></>;
	let withNrspBox = "false";
	if (props.showNrsp) {
		nrspBox = (
			<FsnbNrspSubBox
				fetchStatus={fetchStatus}
				setFetchStatus={setFetchStatus}
				fetchStatusText={fetchStatusText}
				setFetchStatusText={setFetchStatusText}
				vers={props.vers}
				row={props.row}
				getHeight={getHeight}
				setNrspRowsCount={setNrspRowsCount}
			/>
		);
		withNrspBox = "true";
	}

	const tableBody = (
		<Table
			rowData={data}
			columnsData={columnsData}
			scrollBlock={scrollBlock}
			options={{
				selectOptions: {
					controlled: true,
					uncontrolled: false,
					multiple: false,
					expandOnSelect: {
						columnsName: ["name"],
						fontSize: 12,
						tableClass: "FsnbCoefBoxBody",
					},
				},
				displayOptions: {
					scrollHeightControll: 5,
					displayScrollDelay: 20,
					targetRowHeight: 17,
					newResizableColumns: true,
					columnsWithMinWidth: [{ name: "name", minWidth: "200px" }],
				},
			}}
			funcs={{
				setTableData: ({ newTableData }) => setData(newTableData),
			}}
		/>
	);

	return (
		<Draggable handle=".FsnbCoefBoxHeaderLabel">
			<div className="FsnbCoefBox" style={{ width: boxWidth }}>
				{nrspBox}
				<div className="FsnbCoefBoxHeader">
					<div className="FsnbCoefBoxHeaderLabel">Коэффициенты</div>
					{/* <div className="FsnbCoefBoxHeaderName">Coef Name</div> */}
				</div>
				<div className="FsnbCoefBoxBody" with_nrsp_box={withNrspBox} style={{ height: getHeight("coef") }}>
					<div className="FsnbCoefTableLayout" ref={scrollBlock}>
						{tableBody}
					</div>
				</div>
				<div className="FsnbCoefBoxFooter">
					<KsprButton variant="text" label="Закрыть" onClick={props.f_closeCoefBox} />
				</div>
				<AlertLoading fetchStatus={fetchStatus} fetchStatusText={fetchStatusText} func={setFetchStatus} />
			</div>
		</Draggable>
	);
}
